import React from 'react';
import Helmet from 'react-helmet';
import Link from '../common/TrackedLink';

class NotFound extends React.Component {
	render() {
		return (
			<div className="text-center">
				<Helmet>
					<title>Page Not Found | SentrySafe</title>
				</Helmet>
				<div style={{ padding: '30px 10px 50px' }}>
					<div className="row" style={{ maxWidth: 650 }}>
						<h1>Page not found</h1>
						<p>
							We&rsquo;re sorry, the page you requested is unavailable.
							Please modify your request by clicking the back button
							on your browser or you can try to resolve the problem by:
						</p>
						<ul className="text-left" style={{ maxWidth: 550, margin: '0 auto' }}>
							<li>Using the navigation at the top of the page</li>
							<li>Viewing the <Link to="/site-map">site map</Link></li>
							<li>Entering keywords into the search box on the top right of the page</li>
						</ul>
					</div>
				</div>
			</div>
		);
	}
};

NotFound.notFound = true;

export default NotFound;


// WEBPACK FOOTER //
// ./src/pages/notFound/NotFound.js